import React, { useState, useEffect } from 'react'
import loading1 from "../assets/loading.gif"
import { useParams, useNavigate } from 'react-router-dom';
import { API_URL, secret_key } from './Constants';
import Swal from "sweetalert2";
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Modal from 'react-modal';

const customStylesforUnits = {
    content: {
      top: '30%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      minWidth: '350px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      marginTop: '40px'
    },
  };

const CompanyCreditHistory = () => {
    const [loading, setLoading] = useState(true);
    const { companyid } = useParams();

    const queryParams = new URLSearchParams(window.location.search);
  const companyName = queryParams.get('company');

    const encryptedToken = localStorage.getItem('token');
    let decryptedToken = '';

    if (encryptedToken) {
        try {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
        decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
        } catch (error) {
        console.log('Error.');
        }
    }

    const token = `Bearer ${decryptedToken}`;
    let navigate = useNavigate()

    const [creditsHistory, setCreditsHistory] = useState([]);

    const fetchCreditHistory = () => {

        let getCompaniesConfig = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${API_URL}/get_companycredit_history/${companyid}`,
          headers: { 
            'Authorization': token
          }
        };
  
        axios
        .request(getCompaniesConfig)
        .then((response) => {
          setCreditsHistory(response?.data)
          setLoading(false)
        })
        .catch((error) => {
            setLoading(false)
        });
      };
    
      useEffect(() => {
        fetchCreditHistory();
      }, []);

    const [unitsmodalIsOpen, setEditUnitIsOpen] = useState(false);
    const [editunits, seteditunits] = useState({
        amount: 0,
        refrence_no: ""
      });

      const openUnitsModal = () => {
        setEditUnitIsOpen(true);
      }
  
      const closeUnitsModal = () => {
        setEditUnitIsOpen(false);
      }
  
      const handleunitsChange = (e) => {
        const editunitsdata = { ...editunits }
        editunitsdata[e.target.id] = e.target.value
        seteditunits(editunitsdata)
      }
  
      const [isSubmitting, setIsSubmitting] = useState(false);
      const editUnitsDetails = (e) => {
        e.preventDefault();

        if (isSubmitting) {
          return;
        }
  
        setIsSubmitting(true);
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${API_URL}/loadunits/${companyid}`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
          },
          data : editunits
        };
        
        axios.request(config)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Units have been loaded",
          })
          .then(() => {
            navigate(0);
            setIsSubmitting(false);
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.response?.data?.error,
          })
          setIsSubmitting(false);
        });
      }
      
  return (
    <div style={{paddingLeft:'10px'}}>
    <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Companies</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item active">Companies</li>
                </ol>
              </div>
            </div>
          </div>
      </div>

      <Modal
          isOpen={unitsmodalIsOpen}
          onRequestClose={closeUnitsModal}
          style={customStylesforUnits}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Assign units to {companyName}
              <i onClick={closeUnitsModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <form onSubmit={editUnitsDetails}> 
            <div className="content">
                <div className="user-details">
                 
                  <div className="input-box">
                    <span className="details">Reference Number</span>
                    <input type="text"
                      className='unitsINPUT'
                      required 
                      onChange={handleunitsChange}
                      id='refrence_no'
                    />
                  </div>                  
                </div>
                <div className="user-details">
                 
                  <div className="input-box">
                    <span className="details">Amount</span>
                    <input type="number"
                      className='unitsINPUT'
                      required 
                      onChange={handleunitsChange}
                      id='amount'
                    />
                  </div>                  
                </div>
               
                <div className="button">
                  <input type="submit" defaultValue="Assign" />
                </div>
            </div>
            </form>
          </div>

        </Modal>

    <form className="form-inline justify-content-end searchBar">
      <div id="add-btn" onClick={openUnitsModal}>Load Units </div>
      <div className="centered-element">
        <h5>{companyName}</h5>
      </div>
    </form>

    {loading ? (
        <div className="loadingsubcontainer">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      ) : (
    <div className='table-responsive p-0'>
      <table id="example" className="table table-striped">
        <thead>
            <tr>
                <th>SNo</th>
                <th>Amount</th>
                <th>Rate</th>
                <th>Units</th>
                <th>Created At</th>                
            </tr>
        </thead>
        <tbody>
            {creditsHistory.map((credit, index) => (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{credit.amt}</td>
                    <td>{credit.rate}</td>
                    <td>{credit.units}</td>
                    <td>{credit.created_at}</td>
                </tr>
            ))}
        </tbody>
    </table>
      </div>
      )}
      
  </div>
)
}

export default CompanyCreditHistory